export const formatRelativeTimeAndDate = (
    startDateString: string,
    includeFormattedDate?: boolean
): string => {
    const startDate = new Date(startDateString)
    const now = new Date()

    const diffMs = now.getTime() - startDate.getTime()
    const diffMinutes = Math.floor(diffMs / (1000 * 60))
    const diffHours = Math.floor(diffMinutes / 60)

    const formattedDate = startDate.toLocaleString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        timeZone: 'UTC',
    })

    const getTimeAgo = () => {
        if (diffMinutes < 1) {
            return 'Just now'
        } else if (diffMinutes < 60) {
            return `${diffMinutes.toString()} minute${diffMinutes > 1 ? 's' : ''} ago`
        } else if (diffHours < 24) {
            return `${diffHours.toString()} hour${diffHours > 1 ? 's' : ''} ago`
        } else {
            const days = Math.floor(diffHours / 24)
            return `${days.toString()} day${days > 1 ? 's' : ''} ago`
        }
    }

    if (!includeFormattedDate) {
        return getTimeAgo()
    }

    return `${getTimeAgo()} (${formattedDate})`
}
